import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';
import { MailListRowDragData } from 'owa-mail-types/lib/types/MailListRowDragData';
import { Datapoints } from '../datapoints';

export const dropMailItems = action(
    'dropMailItems',
    (dragData: MailListRowDragData, folderId: string) =>
        addDatapointConfig(Datapoints.todoItemActionCreateFromEmail.datapoint(), {
            dragData,
            folderId,
        })
);

export const reorderTodos = action(
    'reorderTodos',
    (draggedTargetId: string, droppedTargetId: string) =>
        addDatapointConfig(Datapoints.todoItemActionReorder.datapoint(), {
            draggedTargetId,
            droppedTargetId,
        })
);

export const dropTodoOnRecentlyCompletedTasks = action(
    'dropTodoOnRecentlyCompletedTasks',
    (itemId: string) =>
        addDatapointConfig(
            Datapoints.todoItemActionMarkCompleteDropOnRecentlyCompleted.datapoint(),
            {
                itemId,
            }
        )
);

export const dropTodoOnEndOfListSpacer = action('dropTodoOnEndOfListSpacer', (itemId: string) =>
    addDatapointConfig(Datapoints.todoItemActionDropOnEndOfListSpacer.datapoint(), {
        itemId,
    })
);

export const moveTaskToTopOfList = action('moveTaskToTopOfList', (itemId: string) =>
    addDatapointConfig(Datapoints.todoItemActionMoveToTop.datapoint(), {
        itemId,
    })
);

export const moveTaskToEndOfList = action('moveTaskToEndOfList', (itemId: string) =>
    addDatapointConfig(Datapoints.todoItemActionMoveToBottom.datapoint(), {
        itemId,
    })
);

export const moveTaskUpTheList = action('moveTaskUpTheList', (itemId: string) =>
    addDatapointConfig(Datapoints.todoItemActionMoveUp.datapoint(), {
        itemId,
    })
);

export const moveTaskDownTheList = action('moveTaskDownTheList', (itemId: string) =>
    addDatapointConfig(Datapoints.todoItemActionMoveDown.datapoint(), {
        itemId,
    })
);
